/*
 * Preggie Bundle-Block
 * -------------------------------------------------------------
 * Der Kaufbutton legt je nach Bundle entweder das Bundle-Produkt
 * selbst als eine Zeile in den Warenkorb, oder die enthaltenen
 * Artikel als eigene Zeilen.
 *
 * Welche Bundles aufgeteilt werden, steht in SPLIT_HANDLES.
 *
 * Aufgeteilt (Stand 05.08.2026: nur wickelrucksack-bundle)
 *   Jeder Artikel wird eine echte Warenkorbzeile mit eigenem
 *   Bild, Preis und Bestand, verbunden ueber die versteckte
 *   Angabe _set, dazu sein Anzeigepreis aus dem Block als
 *   _setpreis. Genau wie die Set-Karte auf der Rucksackseite.
 *   Der Set-Preis MUSS dann von einer Rabattautomatik kommen.
 *   Fuer den Wickelrucksack ist das "Set: Wickelrucksack +
 *   Komfort-Still-BH", 14,90 EUR auf den BH: 89,90 + 34,95
 *   - 14,90 = 109,95.
 *
 * Nicht aufgeteilt (Preistraeger)
 *   Eine Zeile, das Bundle-Produkt zum Set-Preis, die gewaehlten
 *   Artikel haengen als Angaben daran. Noetig ueberall dort, wo
 *   keine passgenaue Automatik existiert.
 *
 *   Das Schwangerschafts-Bundle laeuft seit dem 05.08.2026
 *   wieder so. Sein Setpreis kam aus dem BXGY "Set:
 *   Schwangerschafts-Bundle" und wurde ab zwei zusaetzlichen
 *   Leggings von der 20-Prozent-Staffel verdraengt: die
 *   beworbenen 79,90 fielen dann wortlos weg, gemessen wurden
 *   148,78. Als Preistraeger sind 79,90 der echte Preis der
 *   Bundle-Variante und damit unverdraengbar. Die Staffel auf
 *   zusaetzliche Artikel kommt stattdessen aus BXGY-Automatiken,
 *   die am Bundle-Produkt selbst haengen und den Setpreis
 *   deshalb nicht beruehren koennen.
 *
 * Warum das ueberhaupt zwei Wege sind: Shopify Basic stapelt
 * keine zwei Produktrabatte, es nimmt nur den groesseren. Wo der
 * Set-Preis aus einem Rabatt entsteht, kann eine Mengenstaffel
 * ihn verdraengen (Bundle plus zwei weitere BHs kostete einmal
 * 148,78 statt 142,82). Ein Preistraeger kollidiert mit keiner
 * Staffel, zeigt die Artikel aber nur als Text.
 *
 * Ausverkaufte Kombinationen bleiben sichtbar, werden aber
 * durchgestrichen, mit "ausverkauft" beschriftet und gesperrt.
 *
 * Eine Zeile kann mehrere Produkte zur Auswahl anbieten
 * (Metafeld bundle.alternates). Beim Wechsel werden Bild,
 * Streichpreis und die Farb- und Groessenauswahl neu aufgebaut.
 * Achtung bei aufgeteilten Bundles: jede Alternative braucht
 * dieselbe Rabattautomatik, sonst faellt der Set-Preis weg.
 *
 * Die Warenkorb-Anbindung folgt den Events, die Focal 12.5
 * selbst nutzt: variant:added, cart:updated, cart:refresh mit
 * der Section "mini-cart".
 *
 * Focal rendert den Produkt-Info-Bereich mehrfach (Hauptspalte,
 * Quick-Buy, Sticky-Leiste). Aenderungen werden zwischen allen
 * Kopien gespiegelt.
 *
 * Seit dem 06.08.2026 laeuft der Block auch in der
 * Schnellansicht, die von jeder Produktkarte aus geoeffnet
 * werden kann. Focal baut deren Inhalt bei JEDEM Oeffnen neu auf
 * (QuickBuyDrawer._load) und leert ihn beim Schliessen wieder
 * (innerHTML = ''). Ohne Aufraeumen saehe der Block deshalb nach
 * dem zweiten Oeffnen eine tote Instanz gewinnen, genau wie es
 * in preggie-pdp-bundle.js schon einmal passiert ist. Dagegen
 * stehen hier drei Dinge: livingInstances() haelt nur Instanzen,
 * deren Wurzel noch im Dokument haengt, bindGlobals() registriert
 * den Zuhoerer fuers Absenden genau einmal am Dokument statt
 * einmal je Instanz, und ein MutationObserver startet boot() neu,
 * sobald nachgeladenes Markup auftaucht.
 */
(function () {
  'use strict';

  /* Die Datei wird sowohl vom Bundle-Block selbst als auch von
     der Produktkarte eingebunden. Auf der Bundle-Seite mit einer
     Empfehlungskarte waere sie sonst zweimal aktiv, mit zwei
     Instanzlisten und doppelten Zuhoerern. */
  if (window.__preggieBundleLoaded) return;
  window.__preggieBundleLoaded = true;

  var ROOT_SELECTOR = '[data-pbundle]';
  var SOLDOUT_SUFFIX = ' · ausverkauft';
  /* Seit dem 06.08.2026 leer. Das Wickelrucksack-Bundle war der
     letzte Eintrag und ist jetzt ebenfalls Preistraeger, damit
     beide Kaufwege dasselbe Warenkorbbild erzeugen und der
     Setpreis von keiner Mengenstaffel verdraengt werden kann.
     Ein Handle gehoert nur hier hinein, wenn eine
     Rabattautomatik existiert, die den Setpreis exakt
     herstellt, und wenn sie mit allen anderen aktiven Rabatten
     kombinierbar ist. */
  var SPLIT_HANDLES = [];
  var instances = [];
  var mirroring = false;
  var globalsBound = false;

  /* Instanzen, deren Wurzel aus dem Dokument geflogen ist,
     zaehlen nicht mehr mit. Die Schnellansicht wirft ihren
     Inhalt beim Schliessen weg, ohne diese Filterung wuerde die
     Liste bei jedem Oeffnen wachsen und eine tote Instanz mit
     veralteter Auswahl den Kauf abfangen. */
  function livingInstances() {
    instances = instances.filter(function (instance) {
      return instance.root && document.contains(instance.root);
    });
    return instances;
  }

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function themeSettings() {
    return (window.themeVariables && window.themeVariables.settings) || {};
  }

  function escapeAttr(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function parseProducts(slot) {
    var node = slot.querySelector('[data-pbundle-products]');
    if (!node) return [];
    try {
      var data = JSON.parse(node.textContent);
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function productByHandle(products, handle) {
    for (var i = 0; i < products.length; i++) {
      if (products[i].h === handle) return products[i];
    }
    return products[0] || null;
  }

  function optionSelects(slot) {
    return Array.prototype.slice.call(slot.querySelectorAll('[data-pbundle-option]'));
  }

  function chosenValues(slot) {
    return optionSelects(slot).map(function (select) { return select.value; });
  }

  function sameOptions(variantOptions, chosen) {
    if (!variantOptions || variantOptions.length !== chosen.length) return false;
    for (var i = 0; i < chosen.length; i++) {
      if (String(variantOptions[i]) !== String(chosen[i])) return false;
    }
    return true;
  }

  function findVariant(variants, chosen) {
    for (var i = 0; i < variants.length; i++) {
      if (sameOptions(variants[i].o, chosen)) return variants[i];
    }
    return null;
  }

  function hasAvailable(variants, chosen) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].a && sameOptions(variants[i].o, chosen)) return true;
    }
    return false;
  }

  /* Ein Optionswert gilt als kaufbar, sobald es irgendeine
     kaufbare Variante gibt, die zu den Auswahlen LINKS davon
     passt. Was rechts davon steht, zaehlt bewusst nicht mit.

     Sonst sperrt eine bereits gewaehlte Groesse eine ganze Farbe
     weg, obwohl es die Farbe in einer anderen Groesse sehr wohl
     gibt, und die Kundin kommt nie an diese Kombination heran.
     Gemessen am 06.08.2026 im Schwangerschafts-Bundle: die
     Leggings gibt es in Hellbraun nur in L, Startauswahl ist
     aber Schwarz/S, also war Hellbraun komplett gesperrt und
     der Bestand lag tot. Gleiche Korrektur wie in
     preggie-pdp-bundle.js, dort seit dem 05.08.2026. */
  function hasAvailableForPrefix(variants, chosen, index, value) {
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      if (!variant.a || !variant.o) continue;
      if (String(variant.o[index]) !== String(value)) continue;

      var matches = true;
      for (var j = 0; j < index; j++) {
        if (String(variant.o[j]) !== String(chosen[j])) { matches = false; break; }
      }
      if (matches) return true;
    }
    return false;
  }

  /* Baut die Farb- und Groessenauswahl fuer ein Produkt neu auf.
     Bereits gewaehlte Werte bleiben erhalten, wenn es sie beim
     neuen Produkt auch gibt. */
  function renderOptions(slot, product, previous) {
    var container = slot.querySelector('[data-pbundle-options]');
    if (!container) return;
    var html = '';

    (product.opts || []).forEach(function (option, index) {
      var values = option.v || [];
      var keep = previous && previous[index];
      var selected = values.indexOf(keep) !== -1 ? keep : values[0];

      html += '<label class="pbundle__option">';
      html += '<select data-pbundle-option data-option-position="' + option.p + '" aria-label="' + escapeAttr(option.n) + '">';
      values.forEach(function (value) {
        html += '<option value="' + escapeAttr(value) + '"' + (value === selected ? ' selected' : '') + '>' + escapeAttr(value) + '</option>';
      });
      html += '</select></label>';
    });

    container.innerHTML = html;
  }

  /* Sperrt und streicht alles durch, was mit den Auswahlen
     links davon nicht kaufbar ist. */
  function markAvailability(slot, product) {
    var selects = optionSelects(slot);
    var chosen = selects.map(function (select) { return select.value; });

    selects.forEach(function (select, index) {
      Array.prototype.slice.call(select.options).forEach(function (option) {
        var available = hasAvailableForPrefix(product.vars || [], chosen, index, option.value);
        option.disabled = !available;
        option.textContent = available ? option.value : option.value + SOLDOUT_SUFFIX;
        if (available) {
          option.classList.remove('pbundle__soldout');
        } else {
          option.classList.add('pbundle__soldout');
        }
      });
    });
  }

  /* Faellt die aktuelle Kombination aus (etwa nach einem
     Farbwechsel), wird auf die naechste kaufbare umgestellt.
     Von links nach rechts bleibt dabei so viel stehen wie
     moeglich, die zuerst gewaehlte Farbe hat also Vorrang und
     nur die Groesse rutscht nach. Wer Hellbraun waehlt, landet
     dadurch sofort auf Hellbraun/L statt auf Schwarz. */
  function fixSelection(slot, product) {
    var selects = optionSelects(slot);
    if (!selects.length) return;
    var chosen = selects.map(function (select) { return select.value; });
    var variants = product.vars || [];
    if (hasAvailable(variants, chosen)) return;

    for (var keep = chosen.length - 1; keep >= 0; keep--) {
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        if (!variant.a || !variant.o) continue;

        var matches = true;
        for (var j = 0; j < keep; j++) {
          if (String(variant.o[j]) !== String(chosen[j])) { matches = false; break; }
        }
        if (!matches) continue;

        for (var k = 0; k < selects.length; k++) {
          if (variant.o[k] != null) selects[k].value = variant.o[k];
        }
        return;
      }
    }
  }

  function mirror(slotIdx, origin, handle, values) {
    livingInstances().forEach(function (instance) {
      if (instance.root === origin) return;
      instance.slots.forEach(function (slot) {
        if (slot.getAttribute('data-slot-idx') !== String(slotIdx)) return;

        var productSelect = slot.querySelector('[data-pbundle-product-select]');
        if (productSelect && handle && productSelect.value !== handle) {
          productSelect.value = handle;
          productSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        values.forEach(function (value, index) {
          var select = slot.querySelectorAll('[data-pbundle-option]')[index];
          if (select && select.value !== value) {
            select.value = value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });
  }

  /* Der Bereich, in dem eine Wurzel oder ein Formular sitzt.
     Auf der Produktseite ist das null, in der Schnellansicht der
     Drawer oder das Popover. Damit laesst sich ein Kaufbutton der
     Instanz zuordnen, die im selben Fenster steht. */
  function overlayScope(node) {
    if (!node || !node.closest) return null;
    return node.closest('quick-buy-drawer, quick-buy-popover, .drawer, .popover');
  }

  function instanceForForm(form) {
    var matching = livingInstances().filter(function (instance) {
      return instance.isBundleForm(form);
    });
    if (matching.length < 2) return matching[0] || null;

    var scope = overlayScope(form);
    for (var i = 0; i < matching.length; i++) {
      if (overlayScope(matching[i].root) === scope) return matching[i];
    }
    return matching[0];
  }

  /* Genau ein Zuhoerer fuers Absenden, am Dokument, unabhaengig
     davon wie viele Instanzen es gibt oder gab. Frueher hing er
     an jeder Instanz. Weil der erste registrierte Zuhoerer mit
     stopImmediatePropagation gewinnt, haette dann nach einem
     Neuaufbau des Blocks die aelteste, laengst entfernte Instanz
     den Kauf mit ihrer veralteten Auswahl abgefangen. */
  function bindGlobals() {
    if (globalsBound) return;
    globalsBound = true;

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      var instance = instanceForForm(form);
      if (!instance) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      instance.submit(form);
    }, true);
  }

  function Bundle(root) {
    this.root = root;
    this.handle = root.getAttribute('data-bundle-handle') || 'bundle';
    this.split = SPLIT_HANDLES.indexOf(this.handle) !== -1;
    this.slots = Array.prototype.slice.call(root.querySelectorAll('[data-pbundle-slot]'));
    this.variantIds = (root.getAttribute('data-bundle-variant-ids') || '')
      .split(',')
      .map(function (id) { return id.trim(); })
      .filter(Boolean);
    this.state = [];
    this.busy = false;
    instances.push(this);
    this.init();
  }

  Bundle.prototype.init = function () {
    var self = this;

    this.slots.forEach(function (slot) { self.setupSlot(slot); });
  };

  Bundle.prototype.setupSlot = function (slot) {
    var self = this;
    var slotIdx = parseInt(slot.getAttribute('data-slot-idx'), 10) || 0;
    var priceLocked = slot.getAttribute('data-price-locked') === '1';
    var products = parseProducts(slot);
    var product = productByHandle(products, slot.getAttribute('data-product-handle'));
    if (!product) return;

    var refresh = function () {
      fixSelection(slot, product);
      markAvailability(slot, product);

      var chosen = chosenValues(slot);
      var variant = findVariant(product.vars || [], chosen);

      if (variant) {
        slot.setAttribute('data-variant-id', variant.id);

        var image = slot.querySelector('[data-pbundle-image] img');
        var source = variant.img || product.img;
        if (image && source && image.getAttribute('src') !== source) {
          image.setAttribute('src', source);
          image.removeAttribute('srcset');
        }

        var compare = slot.querySelector('[data-pbundle-compare]');
        if (compare && variant.c) compare.textContent = variant.c;

        if (!priceLocked) {
          var current = slot.querySelector('[data-pbundle-current]');
          if (current && variant.p) current.textContent = variant.p;
        }
      }

      /* Der Anzeigepreis dieser Zeile in Cent, so wie er im Block
         steht. Er stammt aus bundle.prices (data-set-price) und
         faellt sonst auf den Variantenpreis zurueck. Der Warenkorb
         bekommt ihn als Angabe _setpreis mit, damit er dieselben
         Zahlen zeigt wie das Bundle und nicht die Rabattzuteilung
         von Shopify, die alles an eine Zeile haengt. */
      var slotSetPrice = parseInt(slot.getAttribute('data-set-price'), 10);
      if (isNaN(slotSetPrice)) slotSetPrice = -1;
      if (slotSetPrice < 0 && variant && typeof variant.pc === 'number') {
        slotSetPrice = variant.pc;
      }

      self.state[slotIdx] = {
        label: product.l || slot.getAttribute('data-label') || product.h,
        value: chosen.join(' / '),
        isGift: slot.getAttribute('data-is-gift') === '1',
        setPrice: slotSetPrice,
        variantId: variant ? variant.id : parseInt(slot.getAttribute('data-variant-id'), 10)
      };
    };

    slot.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.matches) return;

      if (target.matches('[data-pbundle-product-select]')) {
        var previous = chosenValues(slot);
        product = productByHandle(products, target.value) || product;
        slot.setAttribute('data-product-handle', product.h);
        slot.setAttribute('data-label', product.l || product.t);
        renderOptions(slot, product, previous);
        refresh();
      } else if (target.matches('[data-pbundle-option]')) {
        refresh();
      } else {
        return;
      }

      if (!mirroring) {
        mirroring = true;
        mirror(slotIdx, self.root, product.h, chosenValues(slot));
        mirroring = false;
      }
    });

    refresh();
  };

  Bundle.prototype.isBundleForm = function (form) {
    if (!form.action || form.action.indexOf('/cart/add') === -1) return false;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return false;
    return this.variantIds.indexOf(String(idInput.value)) !== -1;
  };

  /* Zwei Bauformen, siehe Kopf der Datei.

     Aufgeteilt: je Artikel eine echte Warenkorbzeile, verbunden
     ueber die versteckte Angabe _set. Der Warenkorb zeigt sie
     dann untereinander mit Bild, Preis und Ersparnis, der
     Set-Preis kommt aus der Rabattautomatik.

     Preistraeger: eine Zeile, das Bundle-Produkt zum Set-Preis.
     Die Auswahlen stehen sichtbar an der Zeile, die
     Varianten-IDs fuers Lager im versteckten Feld
     _artikel_ids. */
  Bundle.prototype.buildItems = function (form) {
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return [];

    var chosenItems = this.state.filter(Boolean).filter(function (item) {
      return Boolean(item.variantId);
    });

    if (!chosenItems.length) return [];

    if (this.split) {
      var group = chosenItems.map(function (item) { return item.variantId; }).join('-');

      return chosenItems.map(function (item) {
        var properties = { _set: group };
        if (item.setPrice >= 0) {
          properties._setpreis = String(item.setPrice);
        }
        return { id: item.variantId, quantity: 1, properties: properties };
      });
    }

    var properties = {};
    var ids = [];

    chosenItems.forEach(function (item) {
      properties[item.label] = item.value;
      ids.push(item.variantId);
    });

    properties._artikel_ids = ids.join(',');

    return [{ id: parseInt(idInput.value, 10), quantity: 1, properties: properties }];
  };

  Bundle.prototype.submit = function (form) {
    var self = this;
    var items = this.buildItems(form);
    if (!items.length || this.busy) return;
    this.busy = true;

    var buttons = Array.prototype.slice.call(form.querySelectorAll('[type="submit"]'));
    buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    var root = routeRoot();
    var settings = themeSettings();

    var done = function () {
      self.busy = false;
      buttons.forEach(function (b) { b.removeAttribute('aria-busy'); });
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    };

    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: ['mini-cart'] })
    }).then(function (response) {
      return response.json().then(function (json) { return { ok: response.ok, json: json }; });
    }).then(function (result) {
      if (!result.ok) {
        done();
        form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: result.json && result.json.description } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return;
      }

      if (settings.cartType === 'page' || settings.pageType === 'cart') {
        window.location.href = root + 'cart';
        return;
      }

      var added = result.json.items ? result.json.items[0] : result.json;
      form.dispatchEvent(new CustomEvent('variant:added', { bubbles: true, detail: { variant: added } }));

      /* Steht der Kaufbutton in einem Drawer, bleibt der
         Mini-Warenkorb absichtlich zu (openMiniCart unten). Ohne
         weiteres Zutun passierte dann sichtbar gar nichts. Focals
         eigenes Kaufformular loest an dieser Stelle
         cart-notification:show aus, im Quick-Buy-Drawer steht
         genau dafuer ein cart-notification bereit. Auf der
         Produktseite ist closest('.drawer') null, dort aendert
         sich also nichts. */
      if (form.closest('.drawer') !== null) {
        form.dispatchEvent(new CustomEvent('cart-notification:show', {
          bubbles: true,
          cancelable: true,
          detail: { status: 'success', error: '' }
        }));
      }

      return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        cart.sections = result.json.sections;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            cart: cart,
            openMiniCart: settings.cartType === 'drawer' && form.closest('.drawer') === null
          }
        }));
        done();
      });
    }).catch(function () {
      done();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    });
  };

  function boot() {
    bindGlobals();
    livingInstances();

    Array.prototype.slice.call(document.querySelectorAll(ROOT_SELECTOR)).forEach(function (root) {
      if (root.getAttribute('data-pbundle-ready') === '1') return;
      root.setAttribute('data-pbundle-ready', '1');
      new Bundle(root);
    });
  }

  /* Die Schnellansicht laedt ihren Inhalt nach und wirft ihn beim
     Schliessen weg. Beides erreicht weder shopify:section:load
     noch DOMContentLoaded, deshalb der Beobachter. Er startet
     boot() nur, wenn wirklich etwas zu tun ist. */
  if (window.MutationObserver) {
    new MutationObserver(function () {
      for (var i = 0; i < instances.length; i++) {
        if (!document.contains(instances[i].root)) { boot(); return; }
      }
      var roots = document.querySelectorAll(ROOT_SELECTOR);
      for (var j = 0; j < roots.length; j++) {
        if (roots[j].getAttribute('data-pbundle-ready') !== '1') { boot(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
